<template>
    <div class="order-changes-toast" :class="toastConfig.className">
        <div class="order-changes-toast__content">
            <b-avatar
                size="16px"
                class="order-changes-toast__icon mr-75 flex-shrink-0"
            >
                <img
                    width="16"
                    height="16"
                    :src="toastConfig.icon"
                    :alt="type"
                />
            </b-avatar>
            <div class="order-changes-toast__text">
                <p>{{ changes }}</p>
                <button
                    class="order-changes-toast__action"
                    @click="handleOpenOrder"
                >
                    <span :style="`color: ${toastConfig.textColor}`"
                        >Просмотреть изменения</span
                    >
                </button>
            </div>
            <span
                class="cursor-pointer toastification-close-icon ml-auto"
                @click="$emit('close-toast')"
            >
                <feather-icon
                    v-if="!hideClose"
                    size="18"
                    icon="XIcon"
                    class="mb-2"
                />
            </span>
        </div>
    </div>
</template>
<script>
import { computed } from '@vue/composition-api'
import { BAvatar } from 'bootstrap-vue'

import infoIcon from '@/assets/images/icons/toast/info-circle-fill.svg'
import successIcon from '@/assets/images/icons/toast/success-circle-fill.svg'
import warningIcon from '@/assets/images/icons/toast/warning-circle-fill.svg'

export default {
    components: {
        BAvatar,
    },
    props: {
        orderId: {
            type: String,
            default: '',
        },
        changes: {
            type: String,
            default: '',
        },
        hideClose: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'info',
        },
    },
    emits: ['open-order', 'close-toast'],
    setup(props, { emit }) {
        const handleOpenOrder = () => {
            emit('open-order', props.orderId)
        }

        const toastConfig = computed(() => {
            switch (props.type) {
                case 'success':
                    return {
                        className: 'order-changes-toast--success',
                        textColor: '#0a3622',
                        icon: successIcon,
                    }
                case 'warning':
                    return {
                        className: 'order-changes-toast--warning',
                        textColor: '#664d03',
                        icon: warningIcon,
                    }
                default:
                    return {
                        className: 'order-changes-toast--info',
                        textColor: '#343a40',
                        icon: infoIcon,
                    }
            }
        })

        return {
            toastConfig,
            handleOpenOrder,
        }
    },
}
</script>

<style scoped lang="scss">
.order-changes-toast {
    &__content {
        display: flex;
        align-items: flex-start;
        gap: 10px;

        max-width: 480px;
        padding: 8px 16px;
        border-radius: 6px;
    }

    &__icon {
        margin-top: 10px;
    }

    &__text,
    &__action {
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 16px;
        white-space: pre-line;
    }

    &__text {
        padding-top: 8px;
    }

    &__action {
        padding: 8px;
        background: none;
        cursor: pointer;
        line-height: 16px;
        border-radius: 4px;
    }

    &--success {
        .order-changes-toast__content {
            background-color: #d1e7dd;
            color: #0a3622;
            border: 1px solid #75b798;
        }

        .order-changes-toast__icon {
            background-color: #d1e7dd;
        }

        .order-changes-toast__action {
            border: 1px solid #75b798;

            &:hover {
                background: #a3cfbb;
            }
        }
    }

    &--info {
        .order-changes-toast__content {
            background-color: #e9ecef;
            color: #343a40;
            border: 1px solid #ced4da;
        }

        .order-changes-toast__icon {
            background-color: #e9ecef;
        }

        .order-changes-toast__action {
            border: 1px solid #ced4da;

            &:hover {
                background: #ced4da;
            }
        }
    }

    &--warning {
        .order-changes-toast__content {
            background-color: #fff3cd;
            color: #664d03;
            border: 1px solid #ffda6a;
        }

        .order-changes-toast__icon {
            background-color: #fff3cd;
        }

        .order-changes-toast__action {
            border: 1px solid #ffda6a;

            &:hover {
                background: #ffda6a;
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .order-changes-toast__content {
        max-width: 100%;
    }
}
</style>

<style lang="scss">
.dark-layout {
    .order-changes-toast {
        &--success {
            .order-changes-toast__icon {
                background-color: #d1e7dd !important;
            }
        }

        &--info {
            .order-changes-toast__icon {
                background-color: #e9ecef !important;
            }
        }

        &--warning {
            .order-changes-toast__icon {
                background-color: #fff3cd;
            }
        }
    }
}
</style>
